import React from "react";
import { Image, ImageBackground } from "react-native";

// Web shim for react-native-fast-image (a native module → otherwise noop'd, which
// blanked every image rendered through components/common/Image.js, since that
// wrapper hardcodes ImageProvider = fast_image). Map FastImage's API onto the
// react-native-web <Image>: FastImage's source ({uri, headers, priority, cache})
// reduces to {uri}; resizeMode / priority strings match RNW already.
// Native is untouched (the real module loads there).

const resizeMode = {
  contain: "contain",
  cover: "cover",
  stretch: "stretch",
  center: "center",
};
const priority = { low: "low", normal: "normal", high: "high" };
const cacheControl = { immutable: "immutable", web: "web", cacheOnly: "cacheOnly" };

const normalizeSource = (source) => {
  if (source == null) return source;
  if (typeof source === "number") return source; // local require()
  if (typeof source === "object" && source.uri) return { uri: source.uri };
  return source;
};

const FastImage = React.forwardRef(({ source, children, ...rest }, ref) => {
  const src = normalizeSource(source);
  // FastImage allows children (overlay); RNW <Image> does not, so use ImageBackground.
  if (children) {
    return (
      <ImageBackground ref={ref} source={src} {...rest}>
        {children}
      </ImageBackground>
    );
  }
  return <Image ref={ref} source={src} {...rest} />;
});

FastImage.displayName = "FastImageWebShim";
FastImage.resizeMode = resizeMode;
FastImage.priority = priority;
FastImage.cacheControl = cacheControl;
FastImage.preload = () => {};
FastImage.clearMemoryCache = () => Promise.resolve();
FastImage.clearDiskCache = () => Promise.resolve();

export default FastImage;
export { FastImage };
